import React from 'react';
import { Block, FullWidthImage } from './content';
const ImagePreview = _ref => {
  let {
    src
  } = _ref;
  return /*#__PURE__*/React.createElement(Block, {
    textAlign: "center"
  }, /*#__PURE__*/React.createElement(FullWidthImage, {
    src: src
  }));
};
export { ImagePreview };